module.exports = __webpack_public_path__ + "img/medcube_top.b91773f1.jpg";